// Simple Hash-based SPA Router

class Router {
    constructor() {
        this.routes = {};
        this.currentRoute = null;
        this.params = {};

        // Listen for hash changes
        window.addEventListener('hashchange', () => this.handleRoute());
        window.addEventListener('load', () => this.handleRoute());
        
        // Listen for language changes to re-render
        window.addEventListener('languageChanged', () => this.handleRoute());
    }

    /**
     * Register a route handler
     * @param {string} path - Route pattern (e.g., '/site/:id')
     * @param {function} handler - Handler function
     */
    on(path, handler) {
        this.routes[path] = handler;
        return this;
    }

    /**
     * Navigate to a route
     * @param {string} path 
     */
    navigate(path) {
        window.location.hash = path;
    }

    /**
     * Get current hash path
     * @returns {string}
     */
    getPath() {
        return window.location.hash.slice(1) || '/';
    }

    /**
     * Handle current route
     */
    handleRoute() {
        let path = this.getPath();
        
        // Strip query string for matching
        if (path.includes('?')) {
            path = path.split('?')[0];
        }

        this.params = {};

        // Find matching route
        for (const [pattern, handler] of Object.entries(this.routes)) {
            const match = this.matchRoute(pattern, path);
            if (match) {
                this.currentRoute = pattern;
                this.params = match.params;
                handler(match.params);
                return;
            }
        }

        // 404 - No matching route
        if (this.routes['*']) {
            this.routes['*']({});
        }
    }

    /**
     * Match a path against a route pattern
     * @param {string} pattern - Route pattern with :params
     * @param {string} path - Actual path
     * @returns {Object|null} Match result with params
     */
    matchRoute(pattern, path) {
        const patternParts = pattern.split('/').filter(Boolean);
        const pathParts = path.split('/').filter(Boolean);

        if (patternParts.length !== pathParts.length) {
            return null;
        }

        const params = {};

        for (let i = 0; i < patternParts.length; i++) {
            const patternPart = patternParts[i];
            const pathPart = pathParts[i];

            if (patternPart.startsWith(':')) {
                // Parameter
                const paramName = patternPart.slice(1);
                params[paramName] = pathPart;
            } else if (patternPart !== pathPart) {
                // Mismatch
                return null;
            }
        }

        return { params };
    }

    /**
     * Get route parameters
     * @returns {Object}
     */
    getParams() {
        return this.params;
    }
}

// Create singleton instance
const router = new Router();

export default router;
